import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=4551717a&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551717a",
  null
  
)

export default component.exports